import React from 'react';
import Banner from '../../../../../../UI/Banner/Banner';
import bannerImage from "../../../../../../../assets/images/satellite/banner.png";
const OutsourcingProviderBanner = (props) => (
    <Banner
        id="outsourcing-provider-banner"
        className="banner black pb-5 services-banner"
        title="services:outsourcingProvider.section-1.title"
        text="services:outsourcingProvider.section-1.txt"
        t={props.t}
        imageBannerRight={bannerImage}
        timeDelay={1.55}
        noText
    />
);

export default OutsourcingProviderBanner;
